import { render, staticRenderFns } from "./EModalDuplicarAulaInfantil.vue?vue&type=template&id=0d247aa7"
import script from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports